import { NavLink } from 'react-router-dom';
import { 
  HomeIcon, 
  AcademicCapIcon, 
  ShieldExclamationIcon, 
  UserCircleIcon 
} from '@heroicons/react/24/outline';

const UserSidebar = () => {
  const navigation = [
    { name: 'Dashboard', icon: HomeIcon, href: '/' },
    { name: 'Courses', icon: AcademicCapIcon, href: '/courses' },
    { name: 'Phishing Reporter', icon: ShieldExclamationIcon, href: '/reporter' },
    { name: 'Profile', icon: UserCircleIcon, href: '/profile' },
  ];

  return (
    <div className="w-64 bg-white shadow-sm h-[calc(100vh-4rem)]">
      <div className="h-full flex flex-col">
        <nav className="mt-5 flex-1 px-2 space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
                  isActive
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon
                    className={`mr-3 flex-shrink-0 h-6 w-6 ${
                      isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  {item.name}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default UserSidebar; 